import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-alloted-list',
  templateUrl: './not-alloted-list.component.html',
  styleUrls: ['./not-alloted-list.component.css']
})
export class NotAllotedListComponent implements OnInit {

  title = "Not Allotted List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/not-alloted-list/not-alloted-list.component.ts